import api from '../api/api-list'

const state = {
	releaseList: [], // 发布的列表
	releaseTotal: -1, // 发布的总条数
	collectionList: [], // 收藏列表数据
	collectionTotal: -1, // 收藏的所有数量
	interactiveList: [], // 互动列表数据
	interactiveTotal: -1, // 互动的所有数量
}

const actions = {
	// 获取发布列表
	getReleaseData: async function ({ commit, state}, { refresh, payload }) {
		let res = await api.blog.getReleaseList({ ...payload, size: 10 })
		if (res.code === 1000) {
			const newList = refresh ? res.data.news : [ ...state.releaseList, ...res.data.news ]
			commit('setReleaseData', { list: newList, total: res.data.total_count })
		}
	},
	// 获取收藏的文章列表
	getCollectionData: async function ({ commit,state }, { refresh, payload }) {
		let res = await api.blog.getCollectionList({ ...payload, size: 10 })
		if (res.code === 1000) {
			const blogList = refresh ? res.data.news : [ ...state.collectionList, ...res.data.news ]
			commit('setCollectionData', { list: blogList, total: res.data.total_count })
		}
	},
	// 获取互动的文章列表
	getInteractivData: async function ({ commit,state }, { refresh, payload }) {
		let res = await api.blog.getInteractiveList({ ...payload, size: 10 })
		if (res.code === 1000) {
			const blogList = refresh ? res.data.news : [ ...state.interactiveList, ...res.data.news ]
			commit('setInteractiveData', { list: blogList, total: res.data.total_count })
		}
	}
}

const mutations = {
	// 更新发布列表
	setReleaseData (state, { list, total }) {
		state.releaseList = list
		state.releaseTotal = total
	},
	// 更新收藏列表
	setCollectionData (state, { list, total }) {
		state.collectionList = list
		state.collectionTotal = total
	},
	// 更新互动列表
	setInteractiveData (state, { list, total }) {
		state.interactiveList = list
		state.interactiveTotal = total
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
